import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: 'img[appImgFallback]',
})
export class ImgFallbackDirective {
    @Input() appImgFallback = './assets/imgs/profile.png';
    private hadError = false;

    constructor(
        private elementRef: ElementRef,
        private sanitizer: DomSanitizer,
    ) {}

    @HostListener('error')
    onError() {
        if (!this.hadError) {
            this.hadError = true;
            // Sanitize o URL de fallback para evitar problemas de segurança
            const safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.appImgFallback);
            // Não podemos atribuir diretamente o SafeUrl ao src, então usamos o valor sanitizado
            this.elementRef.nativeElement.src = this.appImgFallback;
        }
    }
}
